import React from 'react';
import { motion } from 'framer-motion';
import industryauto from '../Assets/industry&auto.png';
import industryauto1 from '../Assets/industry&auto1.png';
import './Industryauto.css';

const Industryauto = () => {
   const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };
  return (
    <div className="gestion-batiments-wrapper">
      <div className="gestion-batiments-container">
        <h1 className="simple-title"> Electricité & automatisme</h1>
        <div className="imagebatiment">
          <div className="solution-content">
            {[
              {
                image: industryauto1,
                alt: 'industryauto',
                description:
                  'Nous proposons des solutions complètes en électricité industrielle et automatisme pour optimiser le fonctionnement de vos installations. De la conception à la mise en service, nous intervenons sur les armoires électriques, les systèmes de contrôle-commande, les automates programmables (PLC) et les interfaces homme-machine (IHM).',
                reverse: false,
              },
              {
                image: industryauto ,
                alt: 'industryauto1',
                description:
                  'Nos services sont adaptés aux besoins des sites de production souhaitant améliorer la performance, la sécurité et l\'automatisation de leurs processus industriels.',
                reverse: true,
              },
            ].map((block, index) => (
              <div key={index} className={`solution-block ${block.reverse ? 'reverse' : ''}`}>
                <motion.div
                  className="solution-block-image-container"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={imageVariants}
                  custom={index}
                >
                  <img src={block.image} alt={block.alt} className="solution-block-image" />
                </motion.div>
                <motion.div
                  className="solution-block-text-container"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={textVariants}
                  custom={index}
                >
                  <p className="solution-block-description">{block.description}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    
  )
}

export default Industryauto
